/**
 * Menu Configuration Definition
 */
export interface Menu {
  readonly applicationTitle: Array<MenuPanelItem>;
  readonly globalNavigation: Array<MenuPanelItem>;
  readonly localNavigation: Array<MenuPanelItem>;
  readonly topNavigation: Array<MenuPanelItem>;
  readonly utilityToolbar: Array<MenuPanelItem>;
  readonly mobileNavigation: Array<MenuPanelItem>;
  readonly mobileMenuHeaderToolbar: Array<MenuPanelItem>;
}

/**
 * Menu Panel Item Definition
 */
export interface MenuPanelItem {
  id: string;
  type?: string;
  target: string;
  text: string;
  href?: string;
  title?: string;
  external?: boolean;
  embeddedMarkup: boolean;
  menu?: Array<MenuGroupItem & MenuItem>;
  icon?: MenuItemIcon;
  open: boolean; // TODO: refactor
  permissions?: Array<string>;
}

/**
 * Menu Group Item Definition
 */
export interface MenuGroupItem {
  id?: string;
  item?: Array<MenuGroupItem & MenuItem>;
  title?: string;
  type?: string;
  permissions?: Array<string>;
}

/**
 * Menu Item Definition
 */
export interface MenuItem {
  embeddedMarkup: boolean;
  id: string;
  text: string;
  target?: string;
  href?: string;
  external?: boolean;
  permissions?: Array<string>;
  icon?: MenuItemIcon;
  menu?: Array<{ item: Array<MenuItem> }>;
}

export interface MenuItemIcon {
  cssClass: string;
  altText: string;
  height: string;
  width: string;
  url: string;
}

export type FlyoutType = 'primary' | 'secondary';

/**
 * Sticky States
 */
export enum StickyState {
  FULL = '',
  STICKY = 'td-wb-header--sticky'
}

export enum MenuItemType {
  SEPARATOR = 'SEPARATOR',
  TITLE = 'TITLE',
  CONTACT_NUMBER = 'CONTACT_NUMBER',
  TEXT = 'TEXT',
  LINK = 'LINK'
}

export enum FlyoutMenuOverlayPosition {
  START_BOTTOM = 'start-bottom',
  END_BOTTOM = 'end-bottom'
}

export interface MenuLinkBadge {
  link: string;
  permission: string;
}

export const MenuLinkBadgeNew: Array<MenuLinkBadge> = [
  { link: '#/page/preferences/customize-site', permission: 'NOTIFICATION_PREFERENCE' },
  { link: '#/page/transfers/transfers-overview', permission: 'TRANSFER_OVERVIEW' }
];
